export function normalizeHost(value) {
  if (!value) return '';
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
    .split(':')[0];
}

export function detectPartnerPortal(hostname = window.location.hostname, partnerPortalHost = '') {
  if (process.env.REACT_APP_PORTAL_MODE === 'partner') {
    return true;
  }
  const host = normalizeHost(hostname);
  const configured = normalizeHost(partnerPortalHost);
  if (configured && host === configured) {
    return true;
  }
  return host.split('.')[0] === 'partner';
}

export async function copyText(value) {
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
